import React, { useState } from 'react';
import { useTransfers } from './useTransfers';
import { ConfirmationModal } from './Components/ConfirmationModal';
import { RejectedTransfers } from './Components/RejectedTransfers';
import { PendingTransfers } from './Components/PendingTransfers';
import { ScheduledTransfers } from './Components/ScheduledTransfers';
import { TransferTableType, TRANSFERS_TEXT } from './Transfers.meta';
import {
  TableTitle,
  TableWrapper,
} from '../../../../../../../../../CommonComponents/OPL/Table/Table';
import { Text } from '../../../../../../../../../CommonComponents/OPL/Text/Text';
import { Icon } from '../../../../../../../../../CommonComponents/OPL/Icon/Icon';
import { TransferDTO } from '../../../../../../../../api/useTransfersQuery';
import { ScheduledTransferDTO } from '../../../../../../../../api/useScheduledTransfersQuery';

const ComponentMap = {
  rejected: RejectedTransfers,
  pending: PendingTransfers,
  scheduled: ScheduledTransfers,
};

interface TransfersProps {
  transferTableType: TransferTableType;
  managedAccountId: string;
}

export const Transfers: React.FC<TransfersProps> = ({ transferTableType, managedAccountId }) => {
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedTransfer, setSelectedTransfer] = useState<
    null | TransferDTO | ScheduledTransferDTO
  >(null);

  const {
    data: { isLoading: isCancellingOrRemoving },
    actions: { onSubmit },
  } = useTransfers({
    managedAccountId,
    transferTableType,
  });

  const Component = ComponentMap[transferTableType];

  const { modalHeader, tableTitle } = TRANSFERS_TEXT[transferTableType];

  return (
    <>
      {isConfirmationModalOpen && (
        <ConfirmationModal
          onClose={() => setIsConfirmationModalOpen(false)}
          modalHeaderText={modalHeader}
          onConfirmation={async () => {
            await onSubmit(selectedTransfer);
            setIsConfirmationModalOpen(false);
          }}
          isLoading={isCancellingOrRemoving}
        />
      )}

      <TableWrapper mb="24">
        <TableTitle>
          {transferTableType === TransferTableType.Scheduled && (
            <Icon className="far fa-clock" color="neutral.500" mr="8" />
          )}
          <Text display="inline" fontWeight={600} fontSize="h6">
            {tableTitle}
          </Text>
        </TableTitle>

        <Component
          managedAccountId={managedAccountId}
          setSelectedTransfer={setSelectedTransfer}
          setIsConfirmationModalOpen={() => setIsConfirmationModalOpen(true)}
        />
      </TableWrapper>
    </>
  );
};
